enum TabValue {
  leaveRequests = 'leaveRequests',
}

export default TabValue;
